import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['performance'].url + ':' + lstModules['performance'].port;
var tokenid = localStorage.getItem("tokenid");
var academicYearId = localStorage.getItem("academicYearId");
var schoolId = localStorage.getItem("schoolId");


export function getClassData(callback) {
    // console.log("getClassData called");
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/sms/performance/mst/all_section_list',
        method: 'POST',
        params: {},
        headers: { tokenid: tokenid },
        withCredentials: true
    })
    .then((response) => {
        obj.message = response.data.SvcMsg;
        obj.status = response.data.SvcStatus;
        if (response.data.SvcStatus === "Success") {
            obj.lstAllClassSections = response.data.lstAllClassSections;
        }
        callback(obj)
    }).catch((error) => {
        obj.status = 'Exception';
        obj.message = error;
        callback(obj)
    });
}

export function getStudentListSvc(clsId, sectionId, callback) {
    // console.log("getStudentListSvc called");
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/sms/cls/stu/list',
        method: 'POST',
        params: {"classId":clsId, "sectionId":sectionId},
        headers: { tokenid: tokenid },
        withCredentials: true
    })
    .then((response) => {
        obj.message = response.data.SvcMsg;
        obj.status = response.data.SvcStatus;
        if (response.data.SvcStatus === "Success") {
            obj.lstClassStudents = response.data.lstClassStudents;
        }
        callback(obj)
    }).catch((error) => {
        obj.status = 'Exception';
        obj.message = error;
        callback(obj)
    });
}
